module.exports = __webpack_public_path__ + "media/info/info--support-blue-300-1e1459d4.svg";